.mq-image-capture-field {
  --mq-image-capture-size: 148px;
  --mq-image-capture-radius: var(--mq-card-radius, 8px);
  --mq-image-capture-overlay: color-mix(in srgb, var(--ant-color-bg-mask) 82%, transparent);
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--mq-space-md, 16px);
}

.mq-image-capture-field__frame {
  align-items: center;
  aspect-ratio: var(--mq-image-capture-ratio, 1);
  background: var(--ant-color-fill-tertiary);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--mq-image-capture-radius);
  color: var(--ant-color-text-tertiary);
  display: flex;
  flex: 0 0 var(--mq-image-capture-width, var(--mq-image-capture-size));
  height: var(--mq-image-capture-height, auto);
  justify-content: center;
  max-width: min(var(--mq-image-capture-width, var(--mq-image-capture-size)), 100%);
  overflow: hidden;
  position: relative;
  width: var(--mq-image-capture-width, var(--mq-image-capture-size));
}

.mq-image-capture-field__image {
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.mq-image-capture-field__frame--drag-over {
  outline: 2px solid var(--mq-theme-primary);
  outline-offset: 2px;
}

.mq-image-capture-field__preview-trigger {
  background: transparent;
  border: 0;
  cursor: zoom-in;
  height: 100%;
  padding: 0;
  width: 100%;
}

.mq-image-capture-field__preview-trigger:focus-visible {
  outline: 2px solid var(--mq-theme-primary);
  outline-offset: -2px;
}

.mq-image-capture-field__full-preview {
  display: flex;
  justify-content: center;
}

.mq-image-capture-field__full-preview img {
  max-height: calc(64vh / var(--mq-display-zoom, 1));
  max-width: 100%;
  object-fit: contain;
}

.mq-image-capture-field__placeholder {
  align-items: center;
  display: flex;
  font-size: var(--mq-font-size-page-title, 24px);
  justify-content: center;
}

.mq-image-capture-field__overlay {
  align-items: flex-end;
  background: var(--mq-image-capture-overlay);
  display: flex;
  gap: var(--mq-space-xxs, 4px);
  inset: 0;
  justify-content: center;
  opacity: 0;
  padding: var(--mq-space-sm, 12px) 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 160ms ease;
}

.mq-image-capture-field__frame:hover .mq-image-capture-field__overlay,
.mq-image-capture-field__frame:focus-within .mq-image-capture-field__overlay {
  opacity: 1;
}

.mq-image-capture-field__overlay .ck-btn {
  pointer-events: auto;
}

:root[data-theme-family] .mq-image-capture-field__overlay .mq-image-capture-field__control.ck-btn {
  background: var(--mq-image-capture-control-bg);
  border: 1px solid var(--mq-image-capture-control-border);
  color: var(--mq-image-capture-control-ink);
  min-height: 44px;
  min-width: 44px;
  padding: 0;
}

:root[data-theme-family] .mq-image-capture-field__overlay .mq-image-capture-field__control.ck-btn:not(:disabled):hover {
  background: var(--mq-image-capture-control-hover);
  color: var(--mq-image-capture-control-ink);
}

.mq-image-capture-field__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mq-space-xs, 8px);
}

.mq-image-capture-field__camera-preview {
  align-items: center;
  background: var(--ant-color-bg-layout);
  border-radius: var(--mq-card-radius, 8px);
  display: flex;
  justify-content: center;
  margin-bottom: var(--mq-space-md, 16px);
  overflow: hidden;
  width: 100%;
}

.mq-image-capture-field__camera-preview video,
.mq-image-capture-field__camera-preview img {
  background: var(--ant-color-bg-mask);
  display: block;
  max-height: min(calc(64vh / var(--mq-display-zoom, 1)), 520px);
  object-fit: contain;
  width: 100%;
}

.mq-image-capture-field__modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mq-space-xs, 8px);
  justify-content: center;
}

@media (hover: none), (pointer: coarse) {
  .mq-image-capture-field__overlay {
    opacity: 1;
  }
}

@media (max-width: 520px) {
  .mq-image-capture-field {
    --mq-image-capture-size: min(100%, 220px);
    align-items: stretch;
    flex-direction: column;
  }

  .mq-image-capture-field__frame {
    flex-basis: auto;
  }

  .mq-image-capture-field__actions {
    flex-direction: column;
  }
}
